import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AvailabilityProvider } from "@/contexts/AvailabilityContext";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { VideoTour } from "@/components/VideoTour";
import { VillaStory } from "@/components/VillaStory";
import { Highlights } from "@/components/Highlights";
import { Gallery } from "@/components/Gallery";
import { AvailabilityHeatmap } from "@/components/AvailabilityHeatmap";
import { Location } from "@/components/Location";
import { ConciergeServices } from "@/components/ConciergeServices";
import { Amenities } from "@/components/Amenities";
import { Reviews } from "@/components/Reviews";
import { FinalCTA } from "@/components/FinalCTA";
import { BookingForm } from "@/components/BookingForm";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import AdminPanel from "@/components/admin/AdminPanel";
import PrivacyPolicy from "@/components/PrivacyPolicy";

function LandingPage() {
  return (
    <LanguageProvider>
      <AvailabilityProvider>
        <div className="App">
          <Header />
          <main>
            <Hero />
            <VideoTour />
            <VillaStory />
            <div id="highlights"><Highlights /></div>
            <Gallery />
            <div id="booking"><AvailabilityHeatmap /></div>
            <div id="location"><Location /></div>
            <ConciergeServices />
            <div id="amenities"><Amenities /></div>
            <div id="reviews"><Reviews /></div>
            <FinalCTA />
            <BookingForm />
            <FAQ />
          </main>
          <Footer />
          <CookieBanner />
        </div>
      </AvailabilityProvider>
    </LanguageProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
